export enum ServiceVehicleFormVariant {
  SIMPLE = 'simple',
  EXTENDED = 'extended',
}
